import { render, staticRenderFns } from "./CommunityNotificationUI.vue?vue&type=template&id=32bcc878&scoped=true&"
import script from "./CommunityNotificationUI.vue?vue&type=script&lang=js&"
export * from "./CommunityNotificationUI.vue?vue&type=script&lang=js&"
import style0 from "./CommunityNotificationUI.vue?vue&type=style&index=0&id=32bcc878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bcc878",
  null
  
)

export default component.exports